module.exports = "<ng-container *ngIf=\"content$ | async as row\">\n    <item-list [list]=\"row\" [config]=\"config\" [paginate]=\"paginate\" [reveal]=\"reveal\"></item-list>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/list/lazy-item-list/lazy-item-list.template.html
// module id = 762
// module chunks = 2